<template>
  <v-row>
    <v-col cols="12" sm="6">
      <v-select
        :disabled="disabled"
        v-model="regionSeleccionada"
        :items="regiones"
        label="Región"
      ></v-select>
    </v-col>
    <v-col cols="12" sm="6">
      <v-select
        :disabled="!regionSeleccionada || disabled"
        v-model="comunaSeleccionada"
        :items="comunas"
        label="Comuna"
      ></v-select>
    </v-col>
  </v-row>
</template>

<script>
import regionesComunas from "../../helpers/regionesComunas";

export default {
    props: {
    setRegion: {
    type: Function,
    },
    setComuna: {
    type: Function,
    },
    disabled: {
        type: Boolean,
        default() {
        return false
      }
    },
    region: {
      type: [String, Number],
      default(){
        return null
      },
    },
    commune: {
      type: [String, Number],
      default(){
        return null
      }
    }
    },
    data() {
    return {
        regiones: [],
        comunas: [],
        regionSeleccionada: null,
        comunaSeleccionada:null
    }
    },

    methods: {
        getRegiones() {
            regionesComunas.regiones.forEach(region => this.regiones.push(region.NombreRegion))
        },
        getComunas() {
            this.comunas = JSON.parse(JSON.stringify(regionesComunas.regiones.find(region => region.NombreRegion == this.regionSeleccionada).comunas));
        }
    },
    watch: {
        regionSeleccionada: function() {
            this.setRegion(this.regionSeleccionada)
            this.getComunas();
        },
        comunaSeleccionada: function() {
            this.setComuna(this.comunaSeleccionada)
        }
    },
    created() {
    this.getRegiones();
    this.regionSeleccionada = this.region ? this.region : null;
    this.comunaSeleccionada = this.region && this.commune  ? this.commune : null;
  }
};
</script>

<style lang="scss" scoped></style>